export default __webpack_public_path__ + "static/media/pic11.051367bb.PNG";